"use client";

import { createContext, useContext } from "react";

interface ModalContextType {
  openModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({
  children,
  onOpenModal,
}: {
  children: React.ReactNode;
  onOpenModal: () => void;
}) {
  return (
    <ModalContext.Provider value={{ openModal: onOpenModal }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within ModalProvider");
  }
  return context;
}
